<div class="dialog-framework">
  <div mat-dialog-title class="json-titlebar">
    <h1 class="view-json-title">Json Payload</h1>
    <mat-icon [mat-dialog-close]="true" class="json-close-icon">close</mat-icon>
  </div>
  <div mat-dialog-content>
      <pre class="json-text"> {{jsonData | async | json}} </pre>
  </div>
</div>
